import { useLocation, useNavigate } from "react-router";

/**
 * Returns a function to navigate by updating search params rather than overriding
 */
export function useNavigateWithSearchParams() {
  const location = useLocation();
  const navigate = useNavigate();

  return (newParams: Record<string, string | null>) => {
    const current = new URLSearchParams(location.search);

    // Apply new values or delete if null
    Object.entries(newParams).forEach(([key, value]) => {
      if (value === null) {
        current.delete(key);
      } else {
        current.set(key, value);
      }
    });

    navigate({ search: current.toString() }, { replace: true });
  };
}
